/**
 * An item that may belong to a specific player (e.g. a suspension or
 * registration). Items with no `player` are treated as player-agnostic.
 */
export interface PlayerScopedItem {
  player?: { id?: string | null } | null
}

/**
 * Filters a list to the selected player. An item with no `player` object is
 * always kept; an item with a `player` is kept only when its `player.id`
 * matches the selected player. When no player is selected, the list is returned
 * unchanged (same reference).
 *
 * Shared by web and mobile so the Profile's player scoping stays consistent
 * across platforms.
 */
export const filterBySelectedPlayer = <T extends PlayerScopedItem>(
  items: T[] = [],
  selectedPlayerId?: string | null
): T[] => {
  if (!selectedPlayerId) {
    return items
  }
  return items.filter(
    (item) => !item.player || item.player.id === selectedPlayerId
  )
}
